// extracted by mini-css-extract-plugin
export default {"header":"FilterHeader_header__C1Jg7","searchContainer__textfield":"FilterHeader_searchContainer__textfield__M9+Rw"};